export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return (
                    [
                        "refPersonType",
                        "refCompanyType",
                        "companyNameTh",
                        "companyNameEn",
                        "registerDate",
                        "refDepartmentRegister",
                        "refDepartmentRegister.nameEn"
                    ].includes(field?.key) || new RegExp(`^addresses.*$`, "g").test(field?.key)
                );
            },
            visibleField: () => false
        },
        {
            check: ({ field }) => {
                return ["refDepartment.nameEn", "refJobPosition.nameEn"].includes(field?.key);
            },
            inputPropField: () => ({ disabled: true })
        },
        {
            check: ({ field }) => {
                return ["username"].includes(field?.key);
            },
            inputPropField: ({ modelRef }) => {
                return {
                    "onUpdate:value": value => {
                        modelRef.username = value;
                        modelRef.email = value;
                    }
                };
            }
        },
        {
            check: ({ field }) => {
                return ["buttonCheckIdCard"].includes(field?.key);
            },
            visibleField: () => {
                return false;
            }
        }
    ];
};
